import reportRoutes from './route';

export default reportRoutes;